import React from "react";
import { DisplayProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import ReadOnlyField from "../../forms/baseFields/readOnlyField";
import cssExports from "theme/styles/main.module.scss";

const NumberDisplay: React.FC<DisplayProps> = (props: DisplayProps) => {
  return (
    <ReadOnlyField label={props.label} className={cssExports.readOnlyTextField}>
      {LocalizationHelperInstance.getFormattedNumber(props.value)}
    </ReadOnlyField>
  );
};

export default NumberDisplay;
